import initialstate from '../initialstate';
import {GET_RELATED_WCGWS} from '../../actions/actiontypes';
import {labels} from '../../util/utils';

function formatData(data) {
	let result = [];

	data.forEach((riskType) => {
		result.push({
			orgHierarchy: [riskType.id],
			riskTypeId: riskType.id,
			leafLevel: riskType.riskTypeName
		});

		if (riskType.risks.length > 0) {
			riskType.risks.forEach((risk) => {
				result.push({
					orgHierarchy: [riskType.id, risk.id],
					riskId: risk.Id,
					leafLevel: risk.riskName
				});

				if (risk.assertions.length > 0) {
					risk.assertions.forEach((assertion) => {
						result.push({
							orgHierarchy: [riskType.id, risk.id, assertion.id],
							assertionId: assertion.id,
							assertionName: assertion.assertionName,
							assertionAbbreviation: assertion.assertionAbbreviation,
							assertionCraValue: assertion.craValue,
							assertionInherentRiskTypeId: assertion.inherentRiskTypeId,
							assertionControlRiskTypeId: assertion.controlRiskTypeId,
							assertionHasRiskAssociated: assertion.hasRiskAssociated,
							accountName: assertion.accountName
						});

						if (assertion.scots.length > 0) {
							assertion.scots.forEach((scot) => {
								result.push({
									orgHierarchy: [riskType.id, risk.id, assertion.id, scot.id],
									scotId: scot.id,
									leafLevel: scot.scotName
								});

								scot.wcgWs.forEach((wcgw) => {
									result.push({
										orgHierarchy: [riskType.id, risk.id, assertion.id, scot.id, wcgw.id],
										wcgwId: wcgw.id,
										leafLevel: wcgw.wcgwName
									});
								});
							});
						} else {
							result.push({
								orgHierarchy: [riskType.id, risk.id, assertion.id, 0],
								leafLevel: labels.noWcgwsIdentified
							});
						}
					});
				} else {
					result.push({
						orgHierarchy: [riskType.id, risk.id, 0],
						leafLevel: labels.noAssertionsIdentified
					});
				}
			});
		} else {
			result.push({
				orgHierarchy: [riskType.id, 0],
				leafLevel: labels.noRisksIdentified
			});
		}
	});

	return result;
}

export default function relatedWCGWsReducer(state = initialstate.relatedWCGWs, action) {
	switch (action.type) {
		case GET_RELATED_WCGWS:
			return action.response || state;
		default:
			return state;
	}
}
